import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Button, Col, Row, Form } from "react-bootstrap";
import { NewInputText } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { Toggle } from "../../../../../components/superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  add_experience_to_section,
  getExperiencesInRestaurant,
  get_single_page,
} from "../../../../../store/actions/Experience/adminExperienceAction";
import { useFormik } from "formik";
import * as yup from "yup";
import { TextField, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SearchByRestaurant from "../../../superAdminReusable/reusablePopupSuperAdmin/SearchByRestaurant";
import moment from "moment";
import { successAlert } from "../../../../../function/alert";

const validationSchema = yup.object({
  start_date: yup.string().required("Start date is required"),
  start_time: yup.string().required("Start time is required"),
  end_date: yup.string().required("End date is required"),
  end_time: yup.string().required("End time is required"),
  restaurant_id: yup.string().required("Please select a restaurant"),
  experience_id: yup.string().required("Please select an experience"),
});

const AddExp = () => {
  const dispatch = useDispatch();
  const { page_id, section_id } = useParams();
  const auth = useSelector((state) => state.auth);
  const history = useHistory();
  const [pageData, setPageData] = useState({});
  const page = useSelector((state) =>
    state?.superAdminExperience?.pages.filter((e) => e?._id === page_id)
  );

  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (!page?.length)
      dispatch(get_single_page(auth?.user?.accessToken, page_id));
  }, []);

  const formik = useFormik({
    initialValues: {
      page_id: "",
      page_position: "",
      section_id: "",
      section_position: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      status: false,
      restaurant_id: "",
      experience_id: "",
    },
    validationSchema,
    onSubmit: (values) => {
      setDisabled(true);
      const startDate = {
        start_date: moment(
          values.start_date + "T" + values.start_time
        ).valueOf(),
      };
      const end_Date = {
        end_date: moment(values.end_date + "T" + values.end_time).valueOf(),
      };

      values.start = startDate.start_date;
      values.end = end_Date.end_date;

      let formData = pageData || {};
      for (let index = 0; index < formData.sections.length; index++) {
        const section = formData.sections[index];
        if (section?.section_id === section_id) {
          formData.sections[index].experiences.push({
            start_date: values?.start,
            end_date: values?.end,
            status: values?.status,
            restaurant_id: values?.restaurant_id,
            experience_id: values?.experience_id,
            createdAt: new Date(),
            updatedAt: new Date(),
          });
        }
      }

      dispatch(
        add_experience_to_section(
          "ADD_EXPERIENCE",
          page_id,
          formData,
          auth?.user?.accessToken,
          onSuccess,
          () => {
            setDisabled(false);
          }
        )
      );
    },
  });

  const onSuccess = (e) => {
    successAlert("Experience assigned to section successfully.");
    history.goBack();
  };

  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");

  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
    formik.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };

  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  const toggleFunction = (e) => {
    formik.setFieldValue("status", !formik.values.status);
  };

  const [experiences, setExperiences] = useState([]);

  const onSuccessExperiences = (exps) => {
    setExperiences(exps);
  };

  const onChangeRestaurant = (rest_id) => {
    formik.setFieldValue("restaurant_id", rest_id);
    getExperiencesInRestaurant(
      rest_id,
      auth?.user?.accessToken,
      onSuccessExperiences
    );
  };

  useEffect(() => {
    if (page?.length) {
      let section = page[0].sections.filter(
        (_t) => _t.section_id == section_id
      );
      formik.setFieldValue("page_id", page[0].page_id);
      formik.setFieldValue("page_position", page[0].position);
      formik.setFieldValue("section_id", section[0].section_id);
      formik.setFieldValue("section_position", section[0].position);
      setPageData(page[0]);
    }
  }, [page?.length]);

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Add Experience</div>
              </div>
              <Form>
                <Row className="pb-2 align-items-center">
                  <div className="f16-700 w-100 mb-3 ml-3">
                    Start Date/ End Date
                  </div>
                  <Col md={3} xl={2} xs={6} className="pb-3">
                    <TextField
                      id="start_date"
                      label="Start Date"
                      variant="outlined"
                      InputProps={{
                        inputProps: { min: minDate },
                        placeholder: "DD MM YYY",
                      }}
                      type="date"
                      //    defaultValue={minDate}
                      className={`w-100`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="start_date"
                      onChange={handleStartDateChange}
                      value={formik.values.start_date}
                      onBlur={formik.handleBlur}
                    />

                    {formik.errors.start_date && formik.touched.start_date ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.start_date}
                      </div>
                    ) : null}
                  </Col>
                  <div className="f12-400">AT</div>
                  <Col md={3} xl={2} xs={6} className="pb-3">
                    <TextField
                      id="start_time"
                      label="Start Time"
                      variant="outlined"
                      type="time"
                      className={`w-100`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="start_time"
                      onChange={formik.handleChange}
                      value={formik.values.start_time}
                      onBlur={formik.handleBlur}
                    />

                    {formik.errors.start_time && formik.touched.start_time ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.start_time}
                      </div>
                    ) : null}
                  </Col>
                  <Col md={3} xl={2} xs={6} className="pb-3">
                    <TextField
                      id="end_date"
                      label="End Date"
                      variant="outlined"
                      InputProps={{
                        inputProps: { min: minEndDate },
                      }}
                      type="date"
                      className={`w-100`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="end_date"
                      onChange={formik.handleChange}
                      value={formik.values.end_date}
                      onBlur={formik.handleBlur}
                    />

                    {formik.errors.end_date && formik.touched.end_date ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.end_date}
                      </div>
                    ) : null}
                  </Col>
                  <div className="f12-400">AT</div>
                  <Col md={3} xl={2} xs={6} className="pb-3">
                    <TextField
                      id="end_time"
                      label="End Time"
                      variant="outlined"
                      type="time"
                      className={`w-100`}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="end_time"
                      onChange={formik.handleChange}
                      value={formik.values.end_time}
                      onBlur={formik.handleBlur}
                    />

                    {formik.errors.end_time && formik.touched.end_time ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.end_time}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <div className="row mb-3">
                  <div className="d-flex align-items-center">
                    <div className="f16-700 mr-2 pl-3">Active</div>
                    <Toggle
                      checked={formik.values.status}
                      toggleFunction={toggleFunction}
                    />
                  </div>
                </div>
                <div className="row w-25 mt-2">
                  <Col md={6} xs={6}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2">Page ID</div>
                      <NewInputText
                        extraClass="mb-1"
                        name="page_id"
                        maxLength={5}
                        inputType="number"
                        controlClass="page_id"
                        value={formik.values.page_id}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={6}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2">Position</div>
                      <NewInputText
                        extraClass="mb-1"
                        name="page_position"
                        maxLength={5}
                        inputType="number"
                        controlClass="page_position"
                        value={formik.values.page_position}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={6}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2">Section ID</div>
                      <NewInputText
                        extraClass="mb-1"
                        name="section_id"
                        maxLength={5}
                        inputType="number"
                        controlClass="section_id"
                        value={formik.values.section_id}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={6}>
                    <Form.Group className="pb-4">
                      <div className="f16-700 mr-2 my-2">Position</div>
                      <NewInputText
                        extraClass="mb-1"
                        name="section_position"
                        maxLength={5}
                        inputType="number"
                        controlClass="section_position"
                        value={formik.values.section_position}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </div>
                <Col md={8} className="p-0">
                  <SearchByRestaurant
                    onChangeRestaurant={(restaurant_id) => {
                      onChangeRestaurant(restaurant_id);
                    }}
                  />
                  {formik.errors.restaurant_id &&
                  formik.touched.restaurant_id ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.restaurant_id}
                    </div>
                  ) : null}
                  <Form.Group className="pb-4 pt-4">
                    <div className="f16-700 mr-2 my-2">Select Experience</div>
                    <FormControl variant="outlined" fullWidth>
                      <Select
                        value={formik.values.experience_id || 1}
                        onChange={formik.handleChange}
                        inputProps={{
                          name: "experience_id",
                          type: "text",
                        }}
                        fullWidth
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <option value={""} selected>
                          Search Experience
                        </option>
                        {experiences?.length
                          ? experiences.map((exp) => {
                              return (
                                <option
                                  value={exp?._id}
                                  style={{ cursor: "pointer" }}
                                >
                                  {exp?.name}
                                </option>
                              );
                            })
                          : null}
                      </Select>
                    </FormControl>
                    {formik.errors.experience_id &&
                    formik.touched.experience_id ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.experience_id}
                      </div>
                    ) : null}
                  </Form.Group>
                </Col>
                <div className="py-4 d-flex align-items-center">
                  <Button
                    variant="outline-secondary"
                    className="btn-lg mr-4 px-5 btn150px"
                    type="button"
                    onClick={() => history.goBack()}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    className="btn-lg px-5 btn150px"
                    type="button"
                    disabled={disabled}
                    onClick={formik.handleSubmit}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AddExp;
